import { useState } from "react";
import { Card, Nav, Tab } from "react-bootstrap";
import { useSnapshot } from "valtio";
import { appStore } from "@store/appStore";
import OrganizationSftpTab from "../organizations/sftp/components/OrganizationSftpTab";
import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";

const VALID_TABS = ["sftp"];

export default function AccountSetupPage() {
  useDocumentTitle("Account Setup");
  const { loggedInUser } = useSnapshot(appStore);
  const [activeTab, setActiveTab] = useState(VALID_TABS[0]);

  const organizationId = loggedInUser?.organization?.id;
  const hasOrganization = organizationId != null && organizationId > 0;

  return (
    <div className="px-4 py-3">
      <div className="mb-4">
        <h3 className="mb-1 fw-bold">Account Setup</h3>
        <p className="text-muted mb-0">Manage your organization's account settings</p>
      </div>

      {!hasOrganization ? (
        <div className="text-muted text-center py-5">
          No organization is associated with your account. Contact your administrator for access.
        </div>
      ) : (
        <Card className="border-0 shadow-sm">
          <Tab.Container id="account-setup-tabs" activeKey={activeTab} onSelect={(k) => setActiveTab(k || VALID_TABS[0])}>
            <Card.Header className="bg-white border-bottom">
              <Nav variant="tabs" className="nav-tabs-custom">
                <Nav.Item>
                  <Nav.Link eventKey="sftp" className="d-flex align-items-center gap-2">
                    <i className="bi bi-hdd-network"></i>
                    SFTP Settings
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Card.Header>

            <Card.Body className="p-4">
              <Tab.Content>
                <Tab.Pane eventKey="sftp">
                  <OrganizationSftpTab organizationId={organizationId} />
                </Tab.Pane>
              </Tab.Content>
            </Card.Body>
          </Tab.Container>
        </Card>
      )}

      <style>{`
        .nav-tabs-custom .nav-link {
          border: none;
          border-bottom: 2px solid transparent;
          color: #6c757d;
          padding: 0.75rem 1.5rem;
          font-weight: 500;
          border-radius: 0;
        }
        .nav-tabs-custom .nav-link:hover {
          border-bottom-color: #dee2e6;
          color: #495057;
        }
        .nav-tabs-custom .nav-link.active {
          color: #0d6efd;
          border-bottom-color: #0d6efd;
          background: none;
        }
      `}</style>
    </div>
  );
}
